require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-redux-dispatch-an-action-event.json") })
        }
      }, "path---front-end-libraries-redux-dispatch-an-action-event");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-redux-dispatch-an-action-event!./.cache/json/front-end-libraries-redux-dispatch-an-action-event.json
// module id = 2116
// module chunks = 231608221292675